import * as React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import IconButton from "@mui/material/IconButton";
import CardHeader from "@mui/material/CardHeader";
import "./home/home.css";
import "./style.css";
import { useNavigate } from "react-router-dom";
import { formatDate, getImageName } from "../helpers/functions";
import EventForm from "./event/eventForm";
import dayjs from "dayjs";
import { useAppDispatch, useAppSelector } from "../helpers/hooks";
import { updateEvent } from "../features/eventDetails/updateEventSlice";
import {
  listEvent,
  topEvent,
  totalEventCount,
} from "../features/eventDetails/eventListSlice";
import {
  fetchEventDetails,
  saveId,
} from "../features/eventDetails/eventDetailsSlice";
import Toaster from "./toaster";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import ShareIcon from "@mui/icons-material/Share";
import ShareEvent from "../components/eventDetails/shareEvent";
import HourglassTopTwoToneIcon from "@mui/icons-material/HourglassTopTwoTone";
import Tooltip from "@mui/material/Tooltip";
import ManageEventForm from "./manageEvents/manageEventForm/ManageEventForm";

const EventCard = (props: any) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const details = useAppSelector((state) => state.eventDetails.details.event);
  const [open, setOpen] = React.useState(false);
  const [openSharePopup, setOpenSharePopup] = React.useState<boolean>(false);
  const editEventFormTitle = "Update Event";
  const [editEventData, setEditEventData] = React.useState<any>();
  const [openToaster, setOpenToaster] = React.useState(false);
  const [toastMessage, setToastMessage] = React.useState("");
  const [toastType, setToastType] = React.useState("");
  const [cardTitle, setCardTitle] = React.useState(false);
  const [disablePublish, setDisablePublish] = React.useState(true);
  const [isLoading, setIsLoading] = React.useState(false);
  const user = useAppSelector((state) => state.userProfile.profile);
  const eventCategories = useAppSelector(
    (state) => state.eventCategories.eventCategories
  );

  const openDetails = (e: any, id: string) => {
    e.preventDefault();
    // localStorage.setItem("eventId", id);
    dispatch(saveId(id));
    navigate(`/event-details/eventId/${id}`);
  };

  const openEditEventForm = (id: string) => {
    // setDisablePublish(false);
    // console.log(dispatch(fetchEventDetails(id)));
    // dispatch(fetchEventDetails(id));
    // setOpen(true);
    navigate(`/manage-event/${id}`);
  };
  const handlePopupClose = () => {
    setOpen(false);
  };
  const handleFormSubmission = (e: any, postBody: any, files: any, id: any) => {
    e.preventDefault();
    let { eventCategoryName, ...postData } = postBody;
    if (editEventData.allslots < editEventData.totalSlots) {
      setToastMessage(
        "Give total slots should be greater than existing total slots."
      );
      setOpenToaster(true);
      setToastType("error");
      return;
    }
    setToastType("error");
    if (!files.length) {
      setToastMessage("Feature image is required");
      setOpenToaster(true);
      return null;
    } else if (files.length > 5) {
      setToastMessage("Please upload maximum 5 images");
      setOpenToaster(true);
      return null;
    } else if (!validateEventDates(postBody)) {
      return null;
    } else if (
      postBody.location == "" ||
      postBody.location == "Select Location"
    ) {
      setToastMessage("All fields are Mandatory");
      setOpenToaster(true);
      return null;
    } else if (postBody.allGoals == null || postData.allGoals.length === 0) {
      setToastMessage("All fields are Mandatory");
      setOpenToaster(true);
      return null;
    } else if (postBody.venue == "") {
      setToastMessage("All fields are Mandatory");
      setOpenToaster(true);
      return null;
    } else if (postBody.title == "") {
      setToastMessage("All fields are Mandatory");
      setOpenToaster(true);
      return null;
    } else if (postBody.eventCategory?.id == "") {
      setToastMessage("All fields are Mandatory");
      setOpenToaster(true);
      return null;
    } else if (postBody.dept == "" || postBody.dept == undefined) {
      setToastMessage("All fields are Mandatory");
      setOpenToaster(true);
      return null;
    } else if (postBody.contact == "") {
      setToastMessage("All fields are Mandatory");
      setOpenToaster(true);
      return null;
    } else if (postBody.allslots == "" || postBody.allslots == null) {
      setToastMessage("All fields are Mandatory");
      setOpenToaster(true);
      return null;
    } else if (
      postBody.description.replace(/<(.|\n)*?>/g, "").trim().length === 0
    ) {
      setToastMessage("Event description is mandatory");
      setOpenToaster(true);
      return false;
    } else {
      var filter =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!filter.test(postBody.contact)) {
        setToastMessage("Please enter a valid email!");
        setOpenToaster(true);
        return false;
      } else {
        let emailDomain = postBody.contact.split("@");
        if (emailDomain[1] != "mercedes-benz.com") {
          setToastMessage("Only Mercedes Benz email is allowed!");
          setOpenToaster(true);
          return false;
        }
      }
    }
    postData["imageName"] = "";
    let formData = new FormData();

    for (let index = 0; index < postData.eventImages.length; index++) {
      if (postData.eventImages[index].name) {
        delete postData.eventImages[index].name;
      }
    }

    if (files && files.length >= 1) {
      if (files[0]["size"] !== undefined) {
        postData["imageName"] = files[0]["name"];
      } else {
        postData["imageName"] = getImageName(files[0]["imageName"]);
      }
    }

    for (let index = 0; index < files.length; index++) {
      if (files[index]["size"] !== undefined) {
        formData.append("images", files[index], files[index].name);
      }
    }

    const resultId = eventCategories.filter((ec: any, index: number) => {
      return ec.id == postData.eventCategory.id;
    });
    postData.eventCategory = resultId[0];
    delete postData.eventCategoryName;
    formData.append("idToDelete", JSON.stringify(id.flat()));
    formData.append("event", JSON.stringify(postData));
    setIsLoading(true);
    dispatch(updateEvent(formData)).then((res: any) => {
      if (res.meta.requestStatus == "fulfilled") {
        setIsLoading(false);
        setOpenToaster(true);
        dispatch(totalEventCount());
        dispatch(listEvent(1));
        dispatch(topEvent());
        setDisablePublish(true);
        setToastType("success");
        setToastMessage("Event updated successfully!");
        handlePopupClose();
      } else {
        setToastType("error");
        setToastMessage("Error in Updation");
        setOpenToaster(true);
        return null;
      }
    });
  };

  const validateEventDates = (data: any) => {
    let registrationStartDateTime = new Date(
      data.registrationStartDate + " " + data?.registrationStartTime
    );
    let registrationEndDateTime = new Date(
      data.registrationEndDate + " " + data?.registrationEndTime
    );
    let eventstartDateTime = new Date(
      data.eventStartDate + " " + data?.eventStartTime
    );
    let eventEndDateTime = new Date(
      data.eventEndDate + " " + data?.eventEndTime
    );

    if (
      dayjs(registrationStartDateTime).isAfter(
        dayjs(registrationEndDateTime)
      ) ||
      dayjs(registrationStartDateTime).isSame(dayjs(registrationEndDateTime))
    ) {
      setToastMessage(
        "Registration end date must be greater then registration start date."
      );
      setOpenToaster(true);
      return false;
    } else if (
      dayjs(registrationStartDateTime).isAfter(dayjs(eventstartDateTime)) ||
      dayjs(registrationStartDateTime).isSame(dayjs(eventstartDateTime))
    ) {
      setToastMessage(
        "Registration start date must be before event start date."
      );
      setOpenToaster(true);
      return false;
    } else if (
      dayjs(registrationEndDateTime).isAfter(dayjs(eventstartDateTime)) ||
      dayjs(registrationEndDateTime).isSame(dayjs(eventstartDateTime))
    ) {
      setToastMessage("Registration end date must be before event start date.");
      setOpenToaster(true);
      return false;
    } else if (
      dayjs(eventstartDateTime).isAfter(dayjs(eventEndDateTime)) ||
      dayjs(eventstartDateTime).isSame(dayjs(eventEndDateTime))
    ) {
      setToastMessage("Event start date must be before event end date.");
      setOpenToaster(true);
      return false;
    } else return true;
  };

  const handleToasterClose = () => {
    setOpenToaster(false);
  };

  React.useEffect(() => {
    setEditEventData(details);
  }, [details]);

  const handleSharePopupClose = () => {
    setOpenSharePopup(false);
  };

  return (
    <>
      <Card
        sx={{
          borderRadius: 0,
          cursor: "pointer",
          boxShadow: "0px 2px 4px 0px rgba(0, 0, 0, 0.12)",
          transition: "transform 0.22s ease, box-shadow 0.22s ease",
          "&:hover": {
            transform: "translateY(-6px)",
            boxShadow: "0px 10px 28px rgba(0, 0, 0, 0.16)",
          },
        }}
      >
       {user && user.userType == "ADMIN" && !props.event.completedStatus && (
          <CardHeader
            action={
              <IconButton
                aria-label="settings"
                sx={{ background: "white", color: "#0078D6" }}
                onClick={() => openEditEventForm(props.event.id)}
              >
                <ModeEditIcon />
              </IconButton>
            }
            className="card-edit-icon"
          />
       )}
        {user && !props.event.completedStatus && (
          <CardHeader
            action={
              <IconButton
                aria-label="settings"
                id={props.event.id}
                sx={{ background: "white", color: "#0078D6" }}
                onClick={() => setOpenSharePopup(true)}
              >
                <ShareIcon />
              </IconButton>
            }
            className="card-edit-icon"
          />
        )}
        {props.event.userRegistered == 2 && !props.event.completedStatus && (
          <CardHeader
            action={
              <Tooltip
                {...props}
                componentsProps={{
                  tooltip: {
                    sx: {
                      background: "#000",
                      color: "#ddd",
                    },
                  },
                }}
                followCursor
                title={<span>Reserved</span>}
              >
                <IconButton
                  disableRipple
                  aria-label="settings"
                  id={props.event.id}
                  sx={{ background: "#000", color: "#000" }}
                >
                  <HourglassTopTwoToneIcon style={{ fill: "white" }} />
                </IconButton>
              </Tooltip>
            }
            className="card-edit-icon"
          />
        )}
        <CardMedia
          sx={{ height: 240 }}
          image={
            props.event.eventImages && props.event.eventImages.length > 0
              ? props.event.eventImages[0].imageUrl
              : ""
          }
          title="image"
          onClick={(e: any) => openDetails(e, props.event.id)}
        />

        <Typography
          display={"block"}
          gutterBottom
          variant="button"
          sx={{ m: "-40px 0 10px 15px" }}
          color="#212529"
        >
          <span className="event-category-tag">
            {props.event.eventCategoryName &&
            props.event.eventCategoryName != ""
              ? props.event.eventCategoryName
              : "Event Category"}
          </span>
        </Typography>

        <CardContent onClick={(e: any) => openDetails(e, props.event.id)}>
          <Typography pt={"5px"} variant="body2" color={"text.secondary"}>
            {formatDate(props.event.eventStartDate)}
          </Typography>
          <Typography
            style={{ zIndex: 999 }}
            onMouseEnter={() => setCardTitle(true)}
            onMouseLeave={() => setCardTitle(false)}
            fontWeight={400}
            color="#212529"
            gutterBottom
            variant="h6"
            component="div"
            sx={
              !cardTitle
                ? {
                    display: "-webkit-box",
                    overflow: "hidden",
                    WebkitBoxOrient: "vertical",
                    WebkitLineClamp: 1,
                    cursor: "pointer",
                  }
                : {
                    fontWeight: "bold",
                    overflow: "visible",
                  }
            }
          >
            {props.event.title && props.event.title != ""
              ? props.event.title
              : props.event.name}
          </Typography>
          {props.event?.completedStatus || props.event?.deleted ? (
            <Paper
              elevation={0}
              sx={{
                backgroundColor: "#000",
                color: "#fff",
                paddingX: "3%",
                width: "62%",
              }}
            >
              <Typography
                component="span"
                variant="h6"
                fontSize=".9rem"
                fontWeight={600}
              >
                Event Status:{" "}
              </Typography>
              <Typography component="span" variant="subtitle1" fontSize=".9rem">
                {" "}
                {props.event?.deleted ? "Cancelled" : "Completed"}
              </Typography>
            </Paper>
          ) : (
            <Typography
              variant="body1"
              display={"flex"}
              color={
                props.event.registrationStatus && props.event.totalSlots > 0
                  ? "#008DFC"
                  : "error.main"
              }
            >
              {!props.event.upcomingRegistration && (
                <>
                  <Typography>
                    {props.event.totalSlots && props.event.totalSlots != ""
                      ? props.event.totalSlots
                      : 0}{" "}
                    Slots Available{" "}
                  </Typography>
                  <Typography sx={{ paddingLeft: 1, paddingRight: 1 }}>
                    |
                  </Typography>
                </>
              )}
              {props.event.registrationStatus ? (
                <Typography className="hyperlink">Register Now</Typography>
              ) : props.event.upcomingRegistration ? (
                <Typography color={"#008DFC"}>
                  Registrations will open soon
                </Typography>
              ) : (
                <Typography>Registration Closed</Typography>
              )}
            </Typography>
          )}

          <Box display="inline-flex" gap={2} py={2}>
            <LocationOnIcon sx={{ mb: "-4px", fontSize: "1.8rem" }} />
            <Typography
              variant="body1"
              color="#212529"
              sx={{ fontSize: "1.125rem", fontWeight: "400!important" }}
            >
              {props.event.location}
            </Typography>
          </Box>
        </CardContent>
      </Card>
      <Toaster
        openToaster={openToaster}
        type={toastType}
        toastMessage={toastMessage}
        handleToasterClose={handleToasterClose}
      />
     {open && details.id !== 0 && (
        <EventForm
          open={open}
          handleClose={handlePopupClose}
          title={editEventFormTitle}
          data={editEventData}
          handleChange={setEditEventData}
          submitForm={handleFormSubmission}
          disablePublish={disablePublish}
          openToasterForm={openToaster}
          isLoading={isLoading}
        />   
      )}  
      {openSharePopup && (
        <ShareEvent
          open={openSharePopup}
          eventData={props.event}
          handleClose={handleSharePopupClose}
        />
      )}
    </>
  );
};
export default EventCard;
